const BOOK_A_DEMO_URL = "https://www.willow.co/book-a-demo";

// Marketing owns which calendar the page embeds, so a new sales owner needs no app deploy.
// HubSpot only records standard utm_* parameters on the booking, not custom ones like "source".
export type BookADemoSource =
  | "billing"
  | "lockout"
  | "dashboard-checklist"
  | "telenet-checkout"
  | "coaching-upsell"
  | "trial"
  | "profile-limit"
  | "advanced-planning";

export const bookADemoUrl = (source: BookADemoSource): string =>
  `${BOOK_A_DEMO_URL}?utm_source=${encodeURIComponent(source)}&utm_medium=app`;

// The marketing page sends X-Frame-Options: SAMEORIGIN, so the one embedded calendar must stay a direct HubSpot URL.
export const ONBOARDING_MEETING_EMBED_URL =
  "https://meetings-eu1.hubspot.com/ludwig-dumont/trial-onboarding?embed=true";
